import { motion } from "framer-motion";
import { useEffect, useState } from "react";

import curveIcon from "./assets/icon-left.svg";
import arrowIcon from "./assets/icon-moment.svg";

import simage1 from "./assets/simage1.webp";
import simage2 from "./assets/simage2.webp";
import simage3 from "./assets/simage3.webp";
import simage4 from "./assets/simage4.webp";
import simage5 from "./assets/simage5.webp";
import simage6 from "./assets/simage6.webp";
import simage7 from "./assets/simage7.webp";
import simage8 from "./assets/simage8.webp";
import simage9 from "./assets/simage9.webp";
import simage10 from "./assets/simage10.webp";
import simage11 from "./assets/simage11.webp";
import simage12 from "./assets/simage12.webp";
import simage13 from "./assets/simage13.webp";
import simage14 from "./assets/simage14.webp";
import simage15 from "./assets/simage15.webp";
import simage16 from "./assets/simage16.webp";
import simage17 from "./assets/simage17.webp";
import simage18 from "./assets/simage18.webp";

const imagess = [
  simage1, simage2, simage3, simage4, simage5, simage6,
  simage7, simage8, simage9, simage10, simage11, simage12,
  simage13, simage14, simage15, simage16, simage17, simage18,
];

// Hook to get responsive image card dimensions
const useCardSize = () => {
  const [size, setSize] = useState({ width: 420, height: 320 });

  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (w < 640) {
        setSize({ width: 260, height: 200 });       // mobile
      } else if (w < 1024) {
        setSize({ width: 340, height: 260 });       // tablet
      } else if (w < 1440) {
        setSize({ width: 420, height: 320 });       // desktop
      } else {
        setSize({ width: 520, height: 400 });       // monitor/large screen
      }
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return size;
};

// Hook to get responsive SVG curve offset
const useCurveOffset = () => {
  const [offset, setOffset] = useState(80);

  useEffect(() => {
   const update = () => {
      const w = window.innerWidth;
      if (w < 640) setOffset(40);
      else if (w < 1024) setOffset(60);
      else if (w < 1440) setOffset(80);
      else setOffset(100);                          // monitor/large screen
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return offset;
};

const HeroSection = () => {
  const { width: cardWidth, height: cardHeight } = useCardSize();
  const curveOffset = useCurveOffset();

  return (
    <>
       <section className="relative bg-[#f7f8fa] pt-20 pb-0 mb-0 overflow-hidden font-poppins">
        {/* Headings Section */}
        <div className="text-center px-4 max-w-[900px] mx-auto relative">
          <h1 className="text-[40px] sm:text-[52px] md:text-[64px] leading-tight text-gray-900">
            We are <span className="font-bold font-[Aclonica]">Lentera</span>.
          </h1>
 
          <h2 className="text-[30px] sm:text-[42px] md:text-[56px] text-gray-800 mt-1 leading-tight">
            where innovation begins.
          </h2>
 
          <div className="w-[60px] h-[1px] bg-green-600 mx-auto my-5" />
 
          <p className="text-gray-700 text-[16px] sm:text-[12px] md:text-[18px] leading-relaxed ml-5 font-light mt-4 max-w-[800px]">
            In 2019, within a small apartment in suburban Chennai, a bold idea
            was born:
            <span className=" font-semibold inline-block bg-teal-100 px-1.5 rounded-xl mx-1">
              “Build smart technology to help businesses work better”.
            </span>
            What began as a simple spark has grown into a world-class tech
            company — powering the way modern businesses thrive.
          </p>
 
          {/* Left green curve */}
          <img
            src={curveIcon}
            alt="curve"
            className="absolute top-[290px] left-[40] w-[32px] md:w-[38px] hidden md:block"
          />
 
          {/* Right yellow arrow */}
      <div className="hidden lg:flex flex-col items-center absolute bottom-[-80px] top-[220px] -right-[60px] text-sm text-gray-800">
 
  {/* Curved Text */}
  <span className="mb-0 text-center leading-tight rotate-[20deg] ml-20">
    Moments
    <br />
    of Lentera
  </span>
 
  {/* Arrow */}
  <img src={arrowIcon} alt="arrow" className="w-[120px] h-[120px] -mt-6" />
 
</div>
        </div>

        {/* Carousel + curved lens wrapper */}
        <div className="relative mt-10 sm:mt-14 md:mt-13">

          {/* SVG curved top */}
          <div
            className="relative z-10 pointer-events-none w-full"
            style={{ marginBottom: `-${curveOffset}px` }}
          >
            <svg
              viewBox="0 0 1440 160"
              className="w-full"
              preserveAspectRatio="none"
              style={{display: "block", width: "100%", marginLeft: 0, marginRight: 0 }}
            >
              <path
                fill="#f7f8fa"
                d="M0,0 L0,80 Q720,170 1440,80 L1440,0 Z"
              />
            </svg>
          </div>

          {/* Scrolling images */}
          <div className="overflow-hidden relative z-0">
            {/* <motion.div
              className="flex gap-[10px] px-[10px]"
              style={{ width: "max-content" }}
              animate={{ x: ["0%", "-50%"] }}
              // transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
              transition={{ duration: 60, repeat: Infinity, ease: "linear", repeatType: "loop" }}
            > */}
            <motion.div
  className="flex gap-[10px] px-[10px]"
  style={{ 
    width: "max-content",
    willChange: "transform",
    backfaceVisibility: "hidden",
    WebkitBackfaceVisibility: "hidden",
  }}
  animate={{ x: ["0%", "-50%"] }}
  transition={{ duration: 60, repeat: Infinity, ease: "linear", repeatType: "loop" }}
>
              {[...imagess, ...imagess].map((src, i) => (
                <div
                  key={i}
                  className="flex-shrink-0 overflow-hidden"
                  style={{
                    width: `${cardWidth}px`,
                    height: `${cardHeight}px`,
                    borderRadius: "16px",
                  }}
                >
                  <img
                    src={src}
                    alt={`scroll-img-${i}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </motion.div>
          </div>

          {/* SVG curved bottom */}
          <div
            className="relative z-10 pointer-events-none"
            style={{ marginTop: `-${curveOffset}px` }}
          >
            <svg
              viewBox="0 0 1440 160"
              className="w-full"
              preserveAspectRatio="none"
              style={{ display: "block" }}
            >
              <path
                fill="#f7f8fa"
                d="M0,160 L0,80 Q720,-40 1440,80 L1440,160 Z"
              />
            </svg>
          </div>

        </div>
      </section>

      {/* Stats Section */}
      <section className="w-full bg-[#F8F9FB] pb-12 sm:pt-4 sm:pb-16 px-4 sm:px-6 lg:px-20 text-center font-poppins">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto"
        >
          <h2 className="text-4xl sm:text-6xl font-bold leading-tight mb-4">
            <span className="bg-gradient-to-r from-[#07862B] to-[#FFEE2F] bg-clip-text text-transparent">
              6+
            </span>{" "}
            <span className="bg-gradient-to-r from-[#07862B] to-[#FFEE2F] bg-clip-text text-transparent">
              years
            </span>
          </h2>
          <p className="text-gray-800 text-base sm:text-xl">
            of running a business has taught
            <br /> us many things
          </p>
        </motion.div>
      </section>
    </>
  );
};

export default HeroSection;